import { GlobalMediaSourceSettingsSchema, PlexStreamSettingsSchema, } from './schemas/settingsSchemas.js';
export const defaultPlexStreamSettings = PlexStreamSettingsSchema.parse({});
export const defaultGlobalMediaSourceSettings = GlobalMediaSourceSettingsSchema.parse({});
//# sourceMappingURL=MediaSourceSettings.js.map